import React, { useState } from 'react';
import {
    Box,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useDisclosure,
    IconButton,
    useToast,
    Stack,
    HStack,
    Flex,
    Select,
    Link,
    Card,
    CardHeader,
    CardBody,
    Text,
    Icon,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { PiSealCheck } from "react-icons/pi";
import { PiSealQuestion } from "react-icons/pi";
import { getAllGuests } from '../../service/api/rsvp';
import QRCode from 'react-qr-code';
import { addGuest, deleteGuest, getAdminAllGuestInvites, updateGuest } from '../../service/api/event';
import { refreshToken } from '../../service/api/token';
let initialData = [ /* Your initial data here */];

const AdminRsvp = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
    } = useDisclosure();
    const cancelDeleteRef = React.useRef();
    const [data, setData] = useState(initialData);
    const [editingEntry, setEditingEntry] = useState(null);
    const [filter, setFilter] = useState('');

    const [entries, setEntries] = useState([]);
    const emptyAllocatedGuest = { firstName: '', lastName: '' };
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        rsvpResponse: '',
        allocatedGuests: [{ ...emptyAllocatedGuest }],
        rsvpLink: '',
        rsvpQR: '',
    });
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [entryToDelete, setEntryToDelete] = useState(null);
    const toast = useToast();

    const emptyForm = {
        firstName: '',
        lastName: '',
        rsvpResponse: '',
        allocatedGuests: [{ ...emptyAllocatedGuest }],
        rsvpLink: '',
        rsvpQR: '',
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [totalGuests, setTotalGuests] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);


    const handleAddEditEntry = async () => {
        if (!formData.firstName.trim() || !formData.lastName.trim()) {
            toast({ title: 'First name and last name are required.', status: 'warning', duration: 2000 });
            return;
        }

        const namedAllocatedGuests = (formData.allocatedGuests || []).filter(
            (guest) => guest.firstName.trim() || guest.lastName.trim()
        );
        const incompleteAllocatedGuest = namedAllocatedGuests.some(
            (guest) => !guest.firstName.trim() || !guest.lastName.trim()
        );
        if (incompleteAllocatedGuest) {
            toast({
                title: 'Each additional guest needs a first and last name.',
                status: 'warning',
                duration: 2500,
            });
            return;
        }

        try {
            setIsSaving(true);
            const payload = {
                ...formData,
                allocatedGuests: namedAllocatedGuests,
            };
            const response = editingEntry
                ? await updateGuest(editingEntry.id, payload)
                : await addGuest(payload);
            if (!response) {
                toast({
                    title: editingEntry ? 'Could not update guest.' : 'Could not add guest.',
                    status: 'error',
                    duration: 2500,
                });
                return;
            }
            toast({
                title: editingEntry ? 'Entry updated.' : 'Entry added.',
                status: 'success',
                duration: 2000,
            });
            resetForm();
            await initializeGuests();
        } catch (error) {
            toast({
                title: editingEntry ? 'Could not update guest.' : 'Could not add guest.',
                status: 'error',
                duration: 2500,
            });
        } finally {
            setIsSaving(false);
        }
    };


    const initializeGuests = async () => {
        try {
            const appResp = await getAdminAllGuestInvites()
            if (appResp != null) {

                setEntries(appResp);
                setData(appResp)
                refreshToken();
                const totalAllocatedGuests = appResp.length + appResp.reduce(
                    (total, guest) => total + (guest.allocated_guests?.length || 0),
                    0
                );
                setTotalGuests(totalAllocatedGuests);


            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const resetForm = () => {
        setFormData({ ...emptyForm, allocatedGuests: [{ ...emptyAllocatedGuest }] });
        setEditingEntry(null);
        onClose();
    };

    const openAddModal = () => {
        setEditingEntry(null);
        setFormData({ ...emptyForm, allocatedGuests: [{ ...emptyAllocatedGuest }] });
        onOpen();
    };

    const handleEdit = (entry) => {
        const allocatedGuests = (entry.allocated_guests || [])
            .filter((guest) => guest.id !== entry.id)
            .map((guest) => ({
                id: guest.id,
                firstName: guest.first_name || '',
                lastName: guest.last_name || '',
            }));
        setFormData({
            firstName: entry.first_name || '',
            lastName: entry.last_name || '',
            rsvpResponse: '',
            allocatedGuests: allocatedGuests.length ? allocatedGuests : [{ ...emptyAllocatedGuest }],
            rsvpLink: '',
            rsvpQR: '',
        });
        setEditingEntry(entry);
        onOpen();
    };

    const openDeleteDialog = (entry) => {
        setEntryToDelete(entry);
        onDeleteOpen();
    };

    const closeDeleteDialog = () => {
        if (isDeleting) {
            return;
        }
        setEntryToDelete(null);
        onDeleteClose();
    };

    const handleDelete = async () => {
        if (!entryToDelete) {
            return;
        }
        try {
            setIsDeleting(true);
            await deleteGuest(entryToDelete.id);
            toast({ title: 'Entry deleted.', status: 'success', duration: 2000 });
            setEntryToDelete(null);
            onDeleteClose();
            await initializeGuests();
        } catch (error) {
            toast({ title: 'Could not delete guest.', status: 'error', duration: 2500 });
        } finally {
            setIsDeleting(false);
        }
    };


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    React.useEffect(() => {
        initializeGuests();
    }, [])

    const filteredData = data.filter(item => {
        const responseStr = item.has_response ? "yes" : "no";

        const firstName = (item.first_name ?? "").toString().toLowerCase();
        const lastName = (item.last_name ?? "").toString().toLowerCase();
        const filterValue = (filter ?? "").toString().toLowerCase();

        return (
            firstName.includes(filterValue) ||
            lastName.includes(filterValue) ||
            responseStr.includes(filterValue)
        );
    });


    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const indexOfLastEntry = currentPage * itemsPerPage;
    const indexOfFirstEntry = indexOfLastEntry - itemsPerPage;

    const currentItems = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
    const filterChange = (filter) => {

        setFilter(filter);
        setCurrentPage(1);
        handlePageChange(1);
    }
    const pageItemsChange = (items) => {
        setItemsPerPage(items);
        setCurrentPage(1);
        handlePageChange(1);
    }



    return (
        <Box margin={3}>
            <Box overflowX="auto">
                <Card>
                    <CardBody>
                        <Text as='b'>
                            Total Guests Invited: {totalGuests}

                        </Text>
                    </CardBody>
                </Card>
            </Box>
            <Button onClick={openAddModal} colorScheme="teal" mb={4} width="full">
                Add Entry
            </Button>
            <Box overflowX="auto">
                <Input
                    placeholder="Filter by first name, last name, or response"
                    value={filter}
                    onChange={(e) => filterChange(e.target.value)}
                    mb={4}
                />
            </Box>
            <Box overflowX="auto">
                <Stack direction="row">
                    <Select value={itemsPerPage}
                        onChange={(e) => pageItemsChange(Number(e.target.value))}>
                        <option value={10}>
                            10
                        </option>
                        <option value={30}>
                            30
                        </option>
                        <option value={100}>
                            100
                        </option>
                        <option value={data.length}>
                            Show All
                        </option>

                    </Select>
                </Stack>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>Has Response</Th>
                            <Th>First Name</Th>
                            <Th>Last Name</Th>
                            <Th>Additional Guest Allocated</Th>
                            <Th>RSVP Link</Th>
                            <Th>RSVP QR</Th>
                            <Th>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentItems.map((entry) => (
                            <Tr key={entry.id}>
                                <Td>
                                    {entry.has_response ? (
                                        <Flex>
                                            <Stack direction="row">
                                                <Icon color="teal.600" as={PiSealCheck} boxSize={10} />
                                            </Stack>
                                        </Flex>
                                    ) :
                                        (
                                            <Stack direction="row">
                                                <Icon color="red.700" as={PiSealQuestion} boxSize={10} />
                                            </Stack>
                                        )}
                                </Td>
                                <Td>{entry.first_name}</Td>
                                <Td>{entry.last_name}</Td>
                                <Td>
                                    <Text as="b">
                                        ({(entry.allocated_guests || []).length})
                                    </Text>
                                    {(entry.allocated_guests || [])
                                        .map(guest => guest.fullname)
                                        .join(', ')}
                                </Td>
                                <Td>
                                    <Link fontSize='xl' color='teal' href={"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}>{"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}
                                    </Link>
                                </Td>
                                <Td>
                                    <QRCode size={110} value={"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}>
                                    </QRCode></Td>
                                <Td>
                                    <HStack spacing={2}>
                                        <IconButton
                                            aria-label="Edit entry"
                                            icon={<EditIcon />}
                                            colorScheme="teal"
                                            variant="outline"
                                            onClick={() => handleEdit(entry)}
                                        />
                                        <IconButton
                                            aria-label="Delete entry"
                                            icon={<DeleteIcon />}
                                            colorScheme="red"
                                            variant="outline"
                                            onClick={() => openDeleteDialog(entry)}
                                        />
                                    </HStack>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>

            {/* Pagination Controls */}
            <Flex mt={4} justifyContent="space-between" flexWrap="wrap">
                <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    width={{ base: '100%', md: 'auto' }}
                    mb={2}
                >
                    Previous
                </Button>
                <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    width={{ base: '100%', md: 'auto' }}
                    mb={2}
                >
                    Next
                </Button>


            </Flex>

            {/* Modal for Adding/Editing Entries */}
            <Modal isOpen={isOpen} onClose={resetForm} size="md">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{editingEntry ? 'Edit Entry' : 'Add Entry'}</ModalHeader>
                    <ModalBody>
                        <Stack spacing={3}>
                            <Input
                                placeholder="First Name"
                                value={formData.firstName}
                                onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                            />
                            <Input
                                placeholder="Last Name"
                                value={formData.lastName}
                                onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                            />
                            <Select
                                placeholder="RSVP Response"
                                value={formData.rsvpResponse}
                                onChange={(e) => setFormData({ ...formData, rsvpResponse: e.target.value })}
                            >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Select>
                            <Text fontWeight="semibold">Allocated Additional Guests</Text>
                            {(formData.allocatedGuests || []).map((guest, index) => (
                                <Flex key={guest.id || index} gap={2} align="center">
                                    <Input
                                        placeholder="First Name"
                                        value={guest.firstName}
                                        onChange={(e) => {
                                            const allocatedGuests = [...formData.allocatedGuests];
                                            allocatedGuests[index] = {
                                                ...allocatedGuests[index],
                                                firstName: e.target.value,
                                            };
                                            setFormData({ ...formData, allocatedGuests });
                                        }}
                                    />
                                    <Input
                                        placeholder="Last Name"
                                        value={guest.lastName}
                                        onChange={(e) => {
                                            const allocatedGuests = [...formData.allocatedGuests];
                                            allocatedGuests[index] = {
                                                ...allocatedGuests[index],
                                                lastName: e.target.value,
                                            };
                                            setFormData({ ...formData, allocatedGuests });
                                        }}
                                    />
                                    <IconButton
                                        aria-label="Remove additional guest"
                                        icon={<DeleteIcon />}
                                        size="sm"
                                        isDisabled={formData.allocatedGuests.length === 1}
                                        onClick={() => {
                                            const allocatedGuests = formData.allocatedGuests.filter((_, i) => i !== index);
                                            setFormData({
                                                ...formData,
                                                allocatedGuests: allocatedGuests.length
                                                    ? allocatedGuests
                                                    : [{ ...emptyAllocatedGuest }],
                                            });
                                        }}
                                    />
                                </Flex>
                            ))}
                            <Button
                                leftIcon={<AddIcon />}
                                variant="outline"
                                size="sm"
                                onClick={() => setFormData({
                                    ...formData,
                                    allocatedGuests: [...formData.allocatedGuests, { ...emptyAllocatedGuest }],
                                })}
                            >
                                Add another person
                            </Button>

                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" onClick={handleAddEditEntry} isLoading={isSaving}>
                            {editingEntry ? 'Update Entry' : 'Add Entry'}
                        </Button>
                        <Button onClick={resetForm} ml={3}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <AlertDialog
                isOpen={isDeleteOpen}
                leastDestructiveRef={cancelDeleteRef}
                onClose={closeDeleteDialog}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Delete entry
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            Delete {entryToDelete
                                ? `${entryToDelete.first_name} ${entryToDelete.last_name}`
                                : 'this guest'} and their invite link?
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelDeleteRef} onClick={closeDeleteDialog} isDisabled={isDeleting}>
                                Cancel
                            </Button>
                            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isDeleting}>
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box >
    );
};

export default AdminRsvp;
